import { defineComponent as _defineComponent } from 'vue'
import LotAssignmentModal from "@/components/ui/modals/LotAssignmentModal.vue";

  import { ref } from "vue";
  import { useToast } from "vue-toastification";
  
export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmInitialHoldModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    hasMoreInitialHolds: {
      type: Boolean,
      required: true,
    },
  },
  emits: ["close", "confirm"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const toast = useToast();
  const emits = __emit;
  const props = __props;

  function close() {
    emits("close");
  }

  const confirm = () => {
    emits("confirm");
  };

const __returned__ = { toast, emits, props, close, confirm, LotAssignmentModal, ref, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})